import { Card, CardProps } from "@mui/material";
import styles from "./BoxShadowCard.module.scss";

export const BoxShadowCard = (props: CardProps) => (
  <Card
    {...props}
    className={`${styles.boxShadowCard} ${props.className ?? ""}`}
  />
);
